var exports = {
  "kL": "x112a1f60--6b12d7--container",
  "Pf": "x112a1f60--6b12d7--label",
  "Uq": "x112a1f60--6b12d7--value",
};

module.exports = exports;
